import template from './paymentGatewayIframe.html' with { type: 'html' };

export default {
	data() {
		return {
			providerIframeSrc: null
		};
	},
	mounted() {
		window.addEventListener('message', (event) => {
			if (event.data.type === 'checkout-payment_provider-iframe-src') {
				// Catch command to set iframe src for the payment gateway (checkout /:locale/:theme/* path)
				this.providerIframeSrc = event.data.payload;
			} else if (/checkout-payment_/.test(event.data.type)) {
				// Catch every other "checkout-payment" command and pass it to the upper iframe (our application)
				window.parent.postMessage(event.data);
			}
		});
	},
	methods: {
		handleProviderIframeLoadEvent() {
			// Tell the upper iframe (our application) that provider url is loaded
			window.parent.postMessage({
				type: 'checkout-payment_provider-iframe-loaded',
				payload: true
			});
		}
	},
	template
};
